import Footer from "components/Footer";
import FirstScreen from "./FirstScreen";
import Content from "./Content";

const Block = () => {
  return (
    <>
      <FirstScreen />
      <Content />
      <Footer />
    </>
  );
};

export default Block;
